export const COUNTRY_KEY = "country";
export const EXTRACT_FREQUENCY_KEY = "extract_frequency";
export const EXTRACT_TYPE_KEY = "extract_type";
export const INDUSTRY_TYPE_KEY = "industryType";
export const TIME_ZONE_KEY = "timezone";
export const USER_FUNCTION_KEY = "userFunction";

export const timeFormats = [
	{ key: "12 hours", label: "12 hours" },
	{ key: "24 hours", label: "24 hours" },
];

export const yesNoChoices = [
	{ key: "yes", value: "Yes" },
	{ key: "no", value: "No" },
];

export const consentChoices = [
	{ key: "1", value: "Yes" },
	{ key: "0", value: "No" },
];

export const statusChoices = [
	{ key: "1", value: "Active" },
	{ key: "0", value: "Inactive" },
];
